import React from "react";
import hotcut from "../../assets/images/minalogo/finishing.jpg";
import lasercut from "../../assets/images/minalogo/percision.JPG";
import desain from "../../assets/images/minalogo/design.jpg";
import { Link } from "react-router-dom";

const Teammembers = [
  {
    Image: lasercut,
    name: "Laser Cutting",
    position:
      "Pemotongan dengan mesin yang dikerjakan oleh SDM yang berpengalaman untuk memotong bentuk bentuk yang sulit",
  },
  {
    Image: hotcut,
    name: "Finishing Logo",
    position:
      "Terdiri dari lem hot press, neci/list kain, dan kain keras untuk menghasilkan logo yang sempurna",
  },
  {
    Image: desain,
    name: "Desain",
    position:
      "Kami menggunakan designer yang berpengalaman, siap memberikan design label yang terbaik dan sesuai dengan keinginan anda",
  },
];

const Experts = () => {
  return (
    <>
      <section className="row_am experts_team_section">
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="title_badge">Jasa Mina Label</span>
            <h2>Jasa Kami</h2>
            <p>
              Kami memiliki bermacam macam jasa untuk memenuhi kebutuhan
              branding pada produk anda dan kami mampu menyesuaikan budget anda.
            </p>
          </div>
          <div className="row">
            {Teammembers.map((data, index) => (
              <div
                key={index}
                className="col-md-4"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <div className="experts_box" style={{ minHeight: "60vh" }}>
                  <img
                    src={data.Image}
                    alt={`image${index}`}
                    style={{
                      minHeight: "35vh",
                      width: "100%",
                      height: "35vh",
                      objectFit: "cover",
                    }}
                  />
                  <div className="text">
                    <h6>{data.name}</h6>
                    <span>{data.position}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
export default Experts;
